import { Outlet } from 'react-router-dom';
import { uiClasses } from '../components/common/uiClasses';

export function WizardLayout() {
  return (
    <div className={uiClasses.pageShell}>
      <div className="py-6 px-4">
        <Outlet />
      </div>
    </div>
  );
}
